import React, { useRef } from 'react';
import { ReactComponent as TipIcon } from '../../assets/icons/tip.svg?react';
import { styled } from "../../../stitches.config";
import { bodyLarge } from '../../commonStyles/Fonts';
import { Link } from 'react-router-dom';

interface TipButtonProps {
    iconOn: boolean;
    text: string;
    elementref: React.RefObject<HTMLDivElement>;
    id: string;
}

const TipButton = ({ iconOn, text, elementref, id }: TipButtonProps) => {

    const handleClick = () => {
        elementref.current ? elementref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
        }) : null;
    }

    return (

        <ButtonContainer className={bodyLarge()} onClick={handleClick}>
            {text}
            {iconOn ? <TipIcon /> : ""}
        </ButtonContainer>
    )
}

export default TipButton;

const ButtonContainer = styled('button', {
    display: 'flex',
    gap: '24px',
    padding: '12px 20px',
    color: '$grayscale0',
    width: '100%',
    fontWeight: 600,
    alignItems: 'center',
    justifyContent: 'center',
    background: '$primary',
    border: 'none',
    svg: {
        flexShrink: 0,
    },
    '@bp4': {
        width: 'fit-content',
    }
})


